import React, { useEffect, useState } from "react";
import { getFirestore, collection, getDocs, query, orderBy} from "firebase/firestore";
import { initializeApp } from "firebase/app";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../components/AuthContext";


const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

const Notice = () => {
  const [notices, setNotices] = useState([]);
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  const handleAddNotice = () =>{
    navigate('/admin/new');
  }

  useEffect(() => {
    const fetchNotices = async () => {
      try {
        const q = query(collection(db, "notice"), orderBy("date", "desc")); // 📌 최신순 정렬
        const querySnapshot = await getDocs(q);
        const noticesData = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setNotices(noticesData);
      } catch (error) {
        console.error("Error fetching notices: ", error);
      }
    };

    fetchNotices();
  }, []);

  return (
    <div>
      <h3 style={{paddingTop:'2em'}}>알림마당</h3>
      <div className="notice">
      {isAuthenticated && (
          <div className="admin-new-button">
            <button onClick  = {handleAddNotice}>공지추가</button>
          </div>
        )}
      <table className="notice_table">
  <thead>
    <tr style={{height:"2em"}}>
      <th scope="col" className="th-num" style={{ padding: '0.1em' }}>번호</th>
      <th scope="col" className="th-title" style={{ padding: '0.1em' }}>제목</th>
      <th scope="col" className="th-date" style={{ padding: '0.1em' }}>날짜</th>
    </tr>
  </thead>
  <tbody>
    {notices.map((notice, idx) => (
      <tr key={notice.id}>
        <td className="n-index">{idx + 1}</td>
        <td className="n-title">
          <Link to={`/notice/${notice.id}`}>
            <strong>{notice.title}</strong>
          </Link>
        </td>
        <td className="n-date">{notice.date}</td>
      </tr>
    ))}
  </tbody>
</table>
        </div>
    </div>
  );
};

export default Notice
;